/**
 * Configuration du front.
 *
 * La bascule mocks / vrai backend tient dans cette seule variable. Si passer
 * `VITE_USE_MOCKS=false` exigeait de toucher autre chose, c'est que du mock a
 * fuité dans un composant — et c'est un défaut à corriger, pas à contourner.
 */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_URL ?? '/api/v1',
  useMocks: import.meta.env.VITE_USE_MOCKS === 'true',
} as const

/**
 * Amplitude par défaut de la grille de planning (§5.1 du contrat).
 *
 * 06:00–21:00, et non 07:00–19:00 : les tournées du matin partent avant 7 h et
 * les soins du soir vont jusqu'à 21 h. Le serveur renvoie l'amplitude réelle du
 * cabinet dans `GET /planning/semaine` ; ces valeurs ne servent qu'au premier
 * rendu, avant la réponse.
 */
export const AMPLITUDE_DEFAUT = {
  heure_ouverture: '06:00',
  heure_fermeture: '21:00',
  pas_minutes: 30,
} as const

/**
 * Hauteur d'un créneau de 30 minutes, en rem.
 *
 * Constante unique partagée par le CSS et les calculs de position : deux
 * valeurs qui dérivent produisent une grille dont les blocs ne tombent plus en
 * face des heures, et le décalage est invisible tant qu'on ne compare pas.
 */
export const HAUTEUR_CRENEAU_REM = 1.75
